import './Visitors.scss';

import { useLocation, useNavigate } from '@reach/router';
import { Pagination } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRecoilState } from 'recoil';

import LoaderComponent from '../../../../../../components/LoaderCompoment/LoaderComponent';
import { useGetVisitors } from '../../../../../../core/APIHooks/useGetVisitors';
import { useMarkVisitorsNotificationAsRead } from '../../../../../../core/APIHooks/useMarkVisitorsNotificationAsRead';
import { userData } from '../../../../../../recoil/atoms/userDataAtom';
import { authMe } from '../../../../../../services/auth-service/auth.service';
import { Triggers } from '../../../../../../V2/model/Triggers';
import { MEMBERS_ROUTES } from '../../members_routes';
import { FavouriteProfile } from '../MyFavorites/components/FavouriteProfile';

const Visitors = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { visitors, setVisitors } = props;
  const [user] = useRecoilState(userData);
  const query = new URLSearchParams(location.search);
  const perPage = 30;
  const sidebar = useSelector((state) => state.sidebar.sidebar);
  const { data, isLoading } = useGetVisitors(query.get('page'), perPage);
  const { mutate: markVisitors } = useMarkVisitorsNotificationAsRead();

  const handleQuery = (param, value) => {
    param !== 'page' && query.set('page', '1');
    value === 1 ? query.delete(param) : query.set(param, value);
    value === 1
      ? navigate(`${location.pathname}`)
      : navigate(`${location.pathname}?${query.toString()}`);
    scrollToTop();
  };

  useEffect(() => {
    if (visitors > 0 && user.data?.premium) {
      setVisitors();
      markVisitors();
    }
  }, [user.data?.premium]);

  useEffect(() => {
    if (query.has('paymentstatus')) {
      authMe().then((res) => {
        const premium = res.data.data.premium;
        if (!premium) {
          navigate(`${MEMBERS_ROUTES.MEMBERSAREA}${MEMBERS_ROUTES.MEMBERSPRICING}`, {
            state: {
              trigger: Triggers.VISITORS,
              id: undefined,
            },
          });
        }
      });
    } else {
      authMe().then((res) => {
        const premium = res.data.data.premium;
        if (!premium) {
          navigate(`${MEMBERS_ROUTES.MEMBERSAREA}${MEMBERS_ROUTES.MEMBERSPRICING}`, {
            state: {
              trigger: Triggers.VISITORS,
              id: undefined,
            },
          });
        }
      });
    }
  }, [user.data?.premium]);

  const renderProfiles = () => {
    return data?.data.length > 0 ? (
      <div className="ProfilesGridContainer">
        {data.data.map((item) => (
          <FavouriteProfile item={item} key={item.id} />
        ))}
      </div>
    ) : (
      <div className="EmptyArray">Add favorites profiles</div>
    );
  };

  return (
    <div className={sidebar ? 'VisitorsPage-Sidebar' : 'VisitorsPage'} id="scrollTop">
      <div className="VisitorsTitle"> Visitors </div>
      {isLoading ? (
        <LoaderComponent />
      ) : (
        <>
          {renderProfiles()}
          <Pagination
            className={'favouritePagination'}
            defaultCurrent={1}
            current={data?.meta.current_page}
            total={data?.meta.total}
            pageSize={perPage}
            onChange={(page) => handleQuery('page', page)}
            showSizeChanger={false}
            hideOnSinglePage={true}
          />
        </>
      )}
    </div>
  );
};

export default Visitors;
